export const KIOSK_SESSION_LIFECYCLE_FEATURE_KEY = 'KioskSessionLifecycle'

// Read cached org feature flags from redux-persist before the features saga finishes on
// startup. Used by kioskPersistTransform at rehydrate and to avoid blocking prod kiosk
// startup when the switch is off.
export function isKioskSessionLifecycleEnabledFromPersist() {
  try {
    const root = JSON.parse(localStorage.getItem('persist:root'))
    if (!root) {
      return false
    }

    const readSettings = sliceKey => {
      const raw = root[sliceKey]
      if (!raw) {
        return {}
      }
      return JSON.parse(raw).settings || {}
    }

    const feature =
      readSettings('features')[KIOSK_SESSION_LIFECYCLE_FEATURE_KEY] ||
      readSettings('productFeatures')[KIOSK_SESSION_LIFECYCLE_FEATURE_KEY]

    return !!feature?.enabled
  } catch (e) {
    return false
  }
}
